/**
 * =============================================================================
 * offcanvas-progress-bar.js
 * =============================================================================
 * All the code for the offcanvas progress bar.
 * =============================================================================
 */

var OffcanvasProgressBar = {
  lastWidth: null,

  onInit: function() {
    this.animateProgressBar.bind(this);
  },

  onReady: function(){
    const myOffcanvas = document.getElementById('cart-offcanvas');
    myOffcanvas.addEventListener('show.bs.offcanvas', event => {
      this.animateProgressBar();
    })

    document.addEventListener("minicart:updated", () => {
      this.animateProgressBar(); 
    });
  },

  animateProgressBar() {
    const bar = document.querySelector(".progress-bar[data-target-width]");
    if (!bar) return;

    const container = bar.closest('.progress'); // or a specific container
    const containerWidth = container.offsetWidth;

    const shippingThreshold = parseFloat(bar.dataset.shippingThreshold) || 0;
    const giftThreshold = parseFloat(bar.dataset.giftThreshold) || 0;
    const cartTotal = parseFloat(bar.dataset.cartTotal) || 0;

    const targetPercent = parseFloat(bar.getAttribute("data-target-width")) || 0;

    // Convert pixel offsets to percentages
    const offset50px = 0;
    const offset20px = 0;

    if (window.cartSettings.fgwp_enabled) {
      const offset50px = (50 / containerWidth) * 100;
      const offset20px = (20 / containerWidth) * 100;
    }

    let adjustedPercent = targetPercent;

    if (cartTotal < shippingThreshold) {
      adjustedPercent = Math.max(0, targetPercent- offset50px);
    } else if (cartTotal < giftThreshold) {
      adjustedPercent = Math.max(0, targetPercent - offset20px);
    }

    // Use the cached value or get current bar width as a fallback
    let currentPercent = this.lastWidth;

    if (currentPercent === null) {
      // fallback: calculate from actual width
      currentPercent = (parseFloat(getComputedStyle(bar).width) / containerWidth) * 100;
    }

    // Immediately set current width (no transition)
    bar.style.transition = 'none';
    bar.style.width = `${currentPercent}%`;

    // Force reflow so the transition starts from the set width
    void bar.offsetWidth;

    // Then animate to the target
    bar.style.transition = "width 0.6s ease-in-out";
    bar.style.width = `${adjustedPercent}%`;

    this.lastWidth = adjustedPercent; // Cache the last width for future use

  }
}

export default OffcanvasProgressBar;